/*
 * Generate the label slug, so everyone thinks it is the same.
 * @author Aaron Hodge Silver
 */
export const generateLabelSlug = (label) => {
	var stringtouse;
	if (label.label_slug) {
		stringtouse = label.label_slug;
	} else if (label.label_title){
		stringtouse = label.label_title;
	} else {
		stringtouse = label;
	}

	stringtouse = stringtouse.replace(/[^a-zA-Z0-9\s-]/g, '');
	return stringtouse.toLowerCase().replace(/\s+/g, '-');
}

/*
 * Decide which label-related classes belong on this performance.
 * @author Aaron Hodge Silver
 */
export const generateLabelClass = (perf) => {
	let labelclass = '';

	// assigning labels based on remaining ticket numbers
	if (limelight.data.ticket_based_labels.length > 0 && perf.remaining_tickets.length > 0) {
		// Step 1: Sort the array by max_tickets_remaining (smallest first)
		limelight.data.ticket_based_labels.sort((a, b) => parseInt(a.max_tickets_remaining) - parseInt(b.max_tickets_remaining));

		// Step 2: Find the first item with max_tickets_remaining less than remaining_tickets
		let selectedLabel = limelight.data.ticket_based_labels.find(item => parseInt(item.max_tickets_remaining) > parseInt(perf.remaining_tickets));
		if (selectedLabel) {
			// console.log(perf.remaining_tickets + ' tickets is fewer tickets than this label\'s max of ' + selectedLabel.max_tickets_remaining);
			labelclass += ' event-time--' + generateLabelSlug(selectedLabel);
		}
		// if this performance doesn't get a tickets-based label, use the manual label
	} else if (perf.label.length > 0) {
		labelclass += ' event-time--' + generateLabelSlug(perf.label);
	}
	return labelclass;
}

/*
 * After the calendar has rendered, remove some labels from the legend.
 * Remove those that should only show if there's at least one matching performance, if there aren't any.
 * @author Aaron Hodge Silver
 */
export const removeLabels = () => {
	let matchFilters = [];

	limelight.data.labels.filter((item) => {
		if (item.display_legend == "match") {
			matchFilters.push(item);
			return;
		}
		return;
	});

	matchFilters.forEach((label) => {
		var slug = generateLabelSlug(label);

		var any_of_these = document.querySelector(".event-time--" + slug);
		if (!any_of_these) {
			var labelsToRemove = document.querySelectorAll(".calendar__legend-each-" + slug);
			labelsToRemove.forEach((element) => element.remove());
		}
	});
}
